import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=56c32107&scoped=true&"
import script from "./MessageTemplate.vue?vue&type=script&lang=js&"
export * from "./MessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=56c32107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c32107",
  null
  
)

export default component.exports